import { useEffect, useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

// Neue Version erkennen: alle 5 Minuten asset-manifest.json holen und den Namen des
// Haupt-Bundles mit dem geladenen vergleichen. Eine SPA laedt neuen Code sonst erst beim
// naechsten Neuladen — ein Tab bliebe sonst den ganzen Tag auf dem alten Bundle.
// Kein automatischer Reload (Lehre aus dem Login-Loop): nur ein Hinweis mit Knopf.
const POLL_MS = 5 * 60_000;

function geladenesBundle(): string | null {
  const s = Array.from(document.scripts).map((x) => x.src).find((src) => /\/static\/js\/main\.[a-f0-9]+\.js/.test(src));
  return s ? s.replace(/^.*\/static\/js\//, 'static/js/') : null;
}

export default function UpdateHinweis() {
  const [neu, setNeu] = useState(false);
  useEffect(() => {
    const eigenes = geladenesBundle();
    if (!eigenes) return;
    const pruefe = async () => {
      try {
        const r = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const m = await r.json();
        const aktuell: string | undefined = m?.files?.['main.js'];
        if (aktuell && !aktuell.endsWith(eigenes)) setNeu(true);
      } catch { /* offline o.ae. — beim naechsten Mal */ }
    };
    void pruefe();
    const t = setInterval(() => void pruefe(), POLL_MS);
    return () => clearInterval(t);
  }, []);
  if (!neu) return null;
  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-200 bg-amber-50 px-4 py-2 text-[12.5px] text-amber-800">
      <span><strong className="font-semibold">Neue Version verfügbar.</strong> Bitte neu laden, damit alle Funktionen auf dem aktuellen Stand sind.</span>
      <button onClick={() => window.location.reload()} className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-amber-300 bg-white px-2.5 py-1 font-medium text-amber-800 hover:bg-amber-100"><ArrowPathIcon className="h-3.5 w-3.5" /> Neu laden</button>
    </div>
  );
}
